import { useLazyQuery } from '@apollo/client/react';
import { useEffect } from 'react';

import {
  GetWebVisitDetailDocument,
  WebVisitorAppointmentDetailFragment,
} from '~/graphql/generated/graphql';
import { getNode } from '~/graphql/utility';
import { useSubscriptions } from '~/hooks/use-subscriptions';

export const useFetchAppointment = (
  isOpen: boolean,
  appointmentId: string | null,
): {
  loading: boolean;
  appointment?: WebVisitorAppointmentDetailFragment;
} => {
  const [event, clear] = useSubscriptions('Appointment', ['updated']);

  const [getWebVisit, { loading, data }] = useLazyQuery(GetWebVisitDetailDocument, {
    fetchPolicy: 'network-only',
  });
  const appointment = getNode(data, 'Appointment');

  useEffect(() => {
    if (isOpen && appointmentId) {
      getWebVisit({
        variables: {
          id: appointmentId,
        },
      });
    }
  }, [getWebVisit, isOpen, appointmentId]);

  useEffect(() => {
    if (!data) return;
    if (event) {
      clear();
    }
  }, [clear, data, event]);

  useEffect(() => {
    if (event?.actionName === 'updated' && event.typeId === appointmentId) {
      getWebVisit({ variables: { id: appointmentId } });
    }
  }, [appointmentId, event?.actionName, event?.typeId, getWebVisit]);

  return { loading, appointment };
};
